var map = {
	"./Cheflix.png": 852,
	"./MercadoLibre.png": 590,
	"./clientmanager.png": 207,
	"./cryptocurrenc.png": 122,
	"./logo4Patas.png": 24,
	"./logoCalculator.jpg": 215,
	"./logoCrypto.png": 282,
	"./logoEcommerce.png": 436,
	"./logoMMG.png": 292,
	"./logoMarkeTravel.png": 908,
	"./logoMemeGenerator.png": 958,
	"./logoProject.png": 382,
	"./logoProjectCM.png": 311,
	"./logoProjectICW.png": 139,
	"./logoProjectMT.png": 138,
	"./logoProjectSC.png": 815,
	"./logoProjectWeather.png": 875,
	"./medapp.png": 873,
	"./travelguide.png": 948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 937;